import './EditableAttachmentsList.scss';

import React, { useCallback, useMemo } from 'react';

import HorizontalScroll from '../HorizontalScroll';
import Icon from '../icons/Icon';
import Thumbnail from '../Thumbnail/Thumbnail';
import { isValidAttachment } from '../../../data/filters/attachmentsFilters';

const EditableAttachmentsList = (props) => {
    const { className = '', attachments, photoUploadEnabled, videoUploadEnabled, onClick, onDelete } = props,
        filteredAttachments = useMemo(
            () => attachments.filter((attachment) => isValidAttachment(attachment.type || attachment.mimetype, photoUploadEnabled, videoUploadEnabled)),
            [attachments, photoUploadEnabled, videoUploadEnabled]
        );

    const handleDeleteItem = useCallback(
        (attachment) => {
            if (onDelete) onDelete(attachment);
        },
        [onDelete]
    );

    if (!filteredAttachments.length) return null;

    return (
        <HorizontalScroll className={['EditableAttachmentsList', 'graybg', className].join(' ')}>
            <div className="content">
                <ul>
                    {filteredAttachments.map((attachment, i) => {
                        return (
                            <li key={i}>
                                <Thumbnail file={attachment} onClick={onClick} />
                                <button type="button" className="delete" onClick={() => handleDeleteItem(attachment)}>
                                    <Icon src="/img/delete_item_outline_white.png" color="red" />
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </HorizontalScroll>
    );
};

export default EditableAttachmentsList;
